//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['countries', 'address', 'loggedIn'],
  data() {
    return {
      sameAddress: true,
      createAccount: true,
      country: 'CZ',
    };
  },
  methods: {
    sameAddressChange() {
      this.$emit('ship-to-different', !this.sameAddress);
      if (this.sameAddress) {
        this.$emit('country-changed', this.country);
      }
    },
    countryChange() {
      if (this.sameAddress) {
        this.$emit('country-changed', this.country);
      }
    },
    createAccountChanged(event) {
      this.$emit('create-account-changed', event.target.checked);
    },
  },
  mounted() {
    this.country = this.address.country;
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/checkout/BillingFields.vue